export default __webpack_public_path__ + "static/media/03.321fb400.svg";